var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`notification is-${_vm.notification.type}`},[_c('button',{staticClass:"delete",on:{"click":_vm.onDelete}}),_vm._v(" "+_vm._s(_vm.notification.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }